<template>
  <div>
    <div class="relative">
      <div class="absolute bg-design1 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd2.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="absolute bg-design3 mob-hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="flex justify-end relative h-95per">
        <img
          src="../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="h-640px md-h-440px sm-h-578px bg-white"
        />
      </div>
      <div
        class="lg:px-20 md:px-10 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32"
      >
        <div class="lg:w-1/2 md:w-1/2 w-full">
          <div class="">
            <p
              class="font-semibold fsize48 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-5/6"
            >
              {{ selected_event.title }}
            </p>
            <div class="mt-2">
              <!-- <p
                class="fsize18 md-fsize18 sm-fsize14 font-normal lh40px sm-lh20"
              >
                {{ selected_event.description }}
              </p> -->
              <p
                class="fsize18 md-fsize18 sm-fsize14 font-normal lh40px sm-lh20"
              >
                <span class="font-semibold"> Date: </span
                >{{ getDate(selected_event.date) }}
              </p>
              <p
                class="fsize18 md-fsize18 sm-fsize14 font-normal lh40px sm-lh20"
              >
                <span class="font-semibold">Time: </span>
                {{ selected_event.time }}
              </p>
              <!-- <p
                class="fsize18 md-fsize18 sm-fsize14 font-normal lh40px sm-lh20"
              >
                <span class="font-semibold"> Location:</span> Mumbai
              </p> -->
            </div>
          </div>
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-5">
          <img
            :src="`${$imageURL}/${selected_event.image}`"
            class="m-auto custborderradius md:block lg:block hidden"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="lg:px-20 md:px-10 px-5 lg:flex md:flex gap-4 w-full">
      <div class="lg:w-8/12 md:w-6/12">
        <p class="fsize20 md-fsize18 sm-fsize14 font-normal lh40px sm-lh20">
          {{ selected_event.description }}
          <!-- Register and Set reminders for all our upcoming webinars, live
          sessions and events that interest you. Register and Set reminders for
          all our upcoming webinars, live sessions and events that interest you.
          Register and Set reminders for all our upcoming webinars, live
          sessions and events that interest you. Register and Set reminders for
          all our upcoming webinars, live sessions and events that interest you.
          Register and Set reminders for all our upcoming webinars, live
          sessions and events that interest you. -->
        </p>
      </div>
      <div
        class="lg:w-4/12 md:w-6/12 lg:mt-0 md:mt-0 mt-5"
        v-if="selected_event_type == 'Upcoming'"
      >
        <ValidationObserver
          tag="form"
          ref="obs1"
          @submit.prevent="addEventRegistration()"
          class="bg-white h-100"
        >
          <div class="bg-white shadow-lg border rounded-xl p-5">
            <div class="">
              <label class="fsize16 text-dark"
                >First Name<span class="text-danger">*</span></label
              >
              <ValidationProvider
                name="FirstName"
                rules="required"
                v-slot="{ errors }"
              >
                <el-input
                  placeholder="Enter First Name"
                  v-model="eventFirstName"
                ></el-input>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mt-4">
              <label class="fsize16 text-dark"
                >Last Name<span class="text-danger">*</span></label
              >
              <ValidationProvider
                name="LastName"
                rules="required"
                v-slot="{ errors }"
              >
                <el-input
                  placeholder="Enter Last Name"
                  v-model="eventLastName"
                ></el-input>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mt-4">
              <label class="fsize16 text-dark"
                >Email Address<span class="text-danger">*</span></label
              >
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <el-input
                  placeholder="Enter Email Address"
                  v-model="eventEmail"
                ></el-input>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mt-4">
              <label class="fsize16 text-dark"
                >Phone Number<span class="text-danger">*</span></label
              >
              <ValidationProvider
                name="PhoneNo"
                rules="required|numeric|min:10|max:10"
                v-slot="{ errors }"
              >
                <el-input
                  placeholder="Enter Phone Number"
                  v-model="eventPhone"
                ></el-input>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mt-4">
              <label class="fsize16 text-dark"
                >How did you hear about the event?<span class="text-danger"
                  >*</span
                ></label
              >
              <ValidationProvider
                name="eventReference"
                rules="required"
                v-slot="{ errors }"
              >
                <el-select
                  v-model="eventReference"
                  placeholder="Select"
                  class="w-full"
                >
                  <el-option
                    v-for="item in options"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <el-input
                v-if="eventReference == 'Others (Please Specify)'"
                placeholder="Please Specify"
                v-model="otherReference"
              ></el-input>
            </div>
            <div class="mt-6">
              <b-button
                :disabled="
                  eventFirstName == '' ||
                  eventLastName == '' ||
                  eventEmail == '' ||
                  eventPhone == '' ||
                  eventReference == ''
                "
                variant="primary"
                class="w-full"
                @click="addEventRegistration()"
                >Submit</b-button
              >
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { mapState } from "vuex";
import * as rules from "vee-validate/dist/rules";
extend("required", {
  ...rules.required,
  message: "This field is required",
});
extend("integer", {
  ...rules.integer,
  message: "This field must be an integer",
});
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    rules,
    extend,
  },
  data() {
    return {
      options: [
        "Social Media(e.g. Facebook, LinkedIn, Twitter)",
        "Email NewsLetter",
        "Website/Blog",
        "Friend/Collegue",
        "Others (Please Specify)",
      ],

      eventFirstName: "",
      eventLastName: "",
      eventEmail: "",
      eventPhone: "",
      eventReference: "",
      otherReference: "",

      // meta_title: "",
      // meta_description: "",
      // meta_canonical: "",
      // meta_keyword: "",
    };
  },
  // metaInfo() {
  //   return {
  //     title: this.meta_title,
  //     meta: [
  //       {
  //         name: "keyword",
  //         content: this.meta_keyword,
  //       },
  //       {
  //         name: "description",
  //         content: this.meta_description,
  //       },
  //       {
  //         rel: "canonical",
  //         href: this.meta_canonical,
  //       },
  //     ],
  //   };
  // },
  // watch: {
  //   selected_event(value) {
  //     this.meta_title = this.selected_event.metaTitle;
  //     this.meta_description = this.selected_event.metaDesc;
  //     this.meta_canonical = this.selected_event.metaCanonicalTag;
  //     this.meta_keyword = this.selected_event.metaKeyword;
  //   },
  // },
  methods: {
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    async addEventRegistration() {
      this.$refs.obs1.validate().then(async (success) => {
        if (success) {
          let payload = {
            eventID: this.selected_event._id,
            firstName: this.eventFirstName,
            lastName: this.eventLastName,
            email: this.eventEmail,
            phone: this.eventPhone,
            eventReference: this.eventReference,
            othersReference:
              this.otherReference != "" ? this.otherReference : "",
          };

          let result = await this.$store.dispatch("ffc/addEventReg", payload);
          if (result) {
            this.$swal.fire({
              title: "Submitted",
              text: "Successfully!",
              icon: "success",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            this.eventFirstName = "";
            this.eventLastName = "";
            this.eventEmail = "";
            this.eventPhone = "";
            this.eventReference = "";
            this.otherReference = "";
          }

          console.log("SUBMITTTT");
        }
        this.$refs["obs1"].reset();
        this.$refs["obs1"].resetValidation();
      });
    },
  },
  computed: {
    ...mapState("ffc", ["selected_event", "selected_event_type"]),
  },
};
</script>
